let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("o5IuS")).then(() => parcelRequire('hxNsI'));